import { render, staticRenderFns } from "./roundTable.vue?vue&type=template&id=34bcfd1e&"
import script from "./roundTable.vue?vue&type=script&lang=js&"
export * from "./roundTable.vue?vue&type=script&lang=js&"
import style0 from "./roundTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports